import { getRemoteConfig, getValue } from "firebase/remote-config";

const remoteConfig = getRemoteConfig();

remoteConfig.defaultConfig = {
    "currency": "IDR"
};

export const currency = getValue(remoteConfig, "currency").asString();
